import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, LazyAction, type LazyComponent } from 'owa-bundling';
import { options_messageorganization_searchterms } from 'owa-locstrings/lib/strings/options_messageorganization_searchterms.locstring.json';
import { options_messageorganization_title } from 'owa-locstrings/lib/strings/options_messageorganization_title.locstring.json';
import type { LazyOption } from 'owa-options-core';
import { createLazyOption } from 'owa-options-core';
import type { DiscardConversationsOptionState } from './actions/discardStackedModeOptions';
import type { StackedModeOptionsProps } from './components/StackedModeOptions';

const lazyModule = new LazyModule<typeof lazyIndex>(() => import('./lazyIndex'), {
    name: 'common/controls/packages/options/config/mail/owa-conversations-option',
});
export const ConversationsOption: LazyOption = createLazyOption(
    {
        key: 'conversations',
        titleStringKey: options_messageorganization_title,
        searchTermsStringKey: options_messageorganization_searchterms,
        allowedOptionKeys: ['Conversations'],
    },
    lazyModule,
    m => m.fullOption
);

// Delay loaded components
export const StackedModeOptions: LazyComponent<StackedModeOptionsProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.StackedModeOptions);
export const lazySaveStackedModeOptionsFull: LazyAction<
    typeof lazyIndex.saveStackedModeOptionsFull,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.saveStackedModeOptionsFull);
export const lazySaveStackedModeOptionsQuick: LazyAction<
    typeof lazyIndex.saveStackedModeOptionsQuick,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.saveStackedModeOptionsQuick);
export const lazyDiscardStackedModeOptions: LazyAction<
    (state?: DiscardConversationsOptionState) => void,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.discardStackedModeOptions);
export const lazySaveConversationsOptions: LazyAction<
    typeof lazyIndex.saveConversationsOptions,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.saveConversationsOptions);
export const lazySaveConversationsOptionQuick: LazyAction<
    typeof lazyIndex.saveConversationsOptionQuick,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.saveConversationsOptionQuick);
